
import * as moment from "moment";
import { Claims } from "../../constants/authentication/claims";
import { UserClaimsService } from "../../services/authentication/user-claims.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { DataType, DataGridColumn } from "../queries/queries.models";
import { PscActivitiesColumns } from "./psc.models";
import { RightStoreService } from "../../services/rightstore/rightstore.service";
import { ProductCodes } from "../rightstore/rightstore.models";
import { VesselDetailModel } from "../vessels/vessel.models";


export class VesselPscColumns {

    public static getColumns(userClaimsService: UserClaimsService, dialogService: DialogClientService, rightStoreService: RightStoreService, 
        vesselModel: VesselDetailModel) {
        const isCustomer = !userClaimsService.hasPermission(Claims.RightShipUser);

        const columns: DataGridColumn[] = [];
        columns.push(
            <DataGridColumn>{
                columnOrder: 1,
                sortOrder: 2,
                dataType: DataType.Date,
                name: 'submittedDate',
                title: 'Date Occurred',
                isSortable: true,
                valueConverter: (value) => moment(value).format("DD MMM YYYY")
            },
            <DataGridColumn>{
                columnOrder: 2,
                sortOrder: 3,
                dataType: DataType.CustomTemplate,
                isSortable: true,
                name: 'numberOfDeficiencies',
                title: 'Information',
                instancePerRow: true,
                value:
                    `<div>
                    <p class="information">\${item.port? item.port: 'Unknown Port'} (\${item.authority})
                    <span if.bind="item.followUpInspection">Fol: Y</span>
                    <span if.bind="!item.followUpInspection" style="color: \${item.numberOfDeficiencies > 0 && item.shipDetained? '#E61E2F': (item.numberOfDeficiencies > 0 && !item.shipDetained? '#C78800': '#008561')}">Def: \${item.numberOfDeficiencies? item.numberOfDeficiencies: 0}</span>\${!item.followUpInspection? ',&nbsp;': '' }
                    <span if.bind="!item.followUpInspection" style="color: \${item.shipDetained? '#E61E2F': ''}">Det: \${item.shipDetained? 'Y': 'N'}</span></p>
                </div>`,
                parameter: {
                    item: null
                }
            },
            <DataGridColumn>{
                columnOrder: 3,
                sortOrder: 4,
                dataType: DataType.CustomTemplate,
                instancePerRow: true,
                isSortable: true,
                name: 'status',
                title: 'Status',
                value:
                    '<div class="status-badge-value row " if.bind="item.status">' +
                    '   <div>' +
                    '       <div class="row nowrap align-items-middle">' +
                    '       <div class="status-badge-dot">' +
                    '   </div>' +
                    '           <span>${getStatus(isCustomer, item)}</span>' +
                    '   </div>' +
                    '   <span class="status-date">${getDateToString(item.statusDate)}</span></div>' +
                    '   <div class="info" if.bind="item.statusSnippet && item.statusId != 6 && item.statusId != 4">' +
                    '       <i class="icon-info material-icons">info_outline</i>' +
                    '       <div class="status-tooltip">' +
                    '           <div class="wrap-tooltip">' +
                    '           <p class="desc">${item.statusSnippet}</p>' +
                    '       </div>' +
                    '   </div>' +
                    '</div>',
                getCellClass: (item: { entityTypeId: number, status: string, numberOfDeficiencies: number, shipDetained: boolean, concatenatedDataSources: string, statusId: number, pscInspectionStatusId: number }) => {
                    let status = item.status;
                    if (VesselPscColumns.getStatus(true, item)=='Clean') status='clean';
                    return (item && item.status) ? `status-badge ${status.toLowerCase().replace(/[^A-z0-9]+/g, '-')}` : '';
                },
                parameter: {
                    item: null,
                    isCustomer: isCustomer,
                    getStatus: (isCustomer, item) => VesselPscColumns.getStatus(isCustomer, item),
                    getDateToString: (date: Date | string) => VesselPscColumns.getDateToString(date)
                }
            },
            <DataGridColumn>{
                columnOrder: 4,
                dataType: DataType.CustomTemplate,
                value: '<div class="column">' +
                    '<div class="row align-items-middle">' +
                    '<span class="link" mousedown.trigger="itemClick(item)">Submit Close Out Information</span></div>',
                instancePerRow: true,
                isHidden: (item:any) => { return !item.showCloseOutLink},
                parameter: {
                    item: null,
                    itemClick: async (item:any) => {
                        await rightStoreService.submitCloseOut(ProductCodes.PscCloseOutPriority, ProductCodes.PscCloseOutFree, item.pscInspectionId, EntityTypes.PSC, vesselModel.vesselId, null, null);
                        return true;
                    }
                }
            });
        return columns;
    }

    public static getStatus(isCustomer: any, item: any) {
        item.entityTypeId = EntityTypes.PSC; //item in this class always be PSC
        return PscActivitiesColumns.getStatus(isCustomer, item);
    }
    
    public static getDateToString(date: Date | string): string {
        if (!date)
            return 'N/A'

        let val: any = date;

        if (typeof date == 'string')
            val = new Date(date);

        if (val.getUTCMonth() == 0 && val.getUTCDay() == 1 && val.getUTCFullYear() == 1900)
            return 'N/A';

        return date ? moment(date).fromNow() : null;
    }
}
